import { InputNumberLocalized } from '@components'

import styled from '@emotion/styled'

const CURRENCY_SELECT_WIDTH = '96px'

export const ImportedInvoiceReviewAmountFieldWrapper = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr) ${CURRENCY_SELECT_WIDTH};
`

/* The currency select draws the single divider, so the amount drops its own right border. */
export const AmountInput = styled(InputNumberLocalized)`
  border-right-width: 0;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
`
